module.exports = __webpack_public_path__ + "img/tema-1-14.003d92cd.png";